/**
 * Lightweight wrapper around `console.*` that silences logs in production
 * builds while preserving them during development.
 *
 * Use these helpers instead of bare `console.log` / `console.error` to keep
 * the browser console clean for end users and avoid leaking debugging info.
 *
 * `error` is *always* surfaced — we want production bug reports — but the
 * non-critical levels (`log`, `info`, `warn`, `debug`) only fire in dev.
 */

const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production';

function _noop() {}

export const log = isDev ? console.log.bind(console) : _noop;
export const info = isDev ? console.info.bind(console) : _noop;
export const warn = isDev ? console.warn.bind(console) : _noop;
export const debug = isDev ? console.debug.bind(console) : _noop;

// Errors are kept in production so they can be captured by monitoring tools.
export const error = (typeof console !== 'undefined' && console.error)
  ? console.error.bind(console)
  : _noop;

export default { log, info, warn, debug, error };
